import { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import Swiper from "react-id-swiper";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faDownload,
    faCar,
    faChevronLeft,
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import './accent.css';
/**** Fotos Banner ****/
import Slider1 from "../../images/modelos/nuevoaccent2024/banner/accent-banner1.webp";
import Slider2 from "../../images/modelos/nuevoaccent2024/banner/accent-banner2.webp";
import Slider3 from "../../images/modelos/nuevoaccent2024/banner/accent-banner3.webp";
import Slider4 from "../../images/modelos/nuevoaccent2024/banner/accent-banner4.webp";
import Slider5 from "../../images/modelos/nuevoaccent2024/banner/accent-banner5.webp";
/****Fotos calidad de tiempo ****/
import CalidadTiempo1 from "../../images/modelos/nuevoaccent2024/calidad/fotos calidad de tiempo.webp";
import CalidadTiempo2 from "../../images/modelos/nuevoaccent2024/calidad/fotos calidad de tiempo2.webp";
import Galeria1 from "../../images/modelos/nuevoaccent2024/galeria/galeria1.webp";
import Galeria2 from "../../images/modelos/nuevoaccent2024/galeria/galeria2.webp";
import Galeria3 from "../../images/modelos/nuevoaccent2024/galeria/galeria3.webp";
import Galeria4 from "../../images/modelos/nuevoaccent2024/galeria/galeria4.webp";
import Galeria5 from "../../images/modelos/nuevoaccent2024/galeria/galeria5.webp";
import './accent.css';
/****Fotos disenio ****/
import Frontal from "../../images/modelos/nuevoaccent2024/disenio/Frontal/banner-frontal.webp";
import Frontal2 from "../../images/modelos/nuevoaccent2024/disenio/Frontal/frontal2.webp";
import Frontal3 from "../../images/modelos/nuevoaccent2024/disenio/Frontal/frontal3.webp";
import Lateral1 from "../../images/modelos/nuevoaccent2024/disenio/Lateral/lateral1.webp";
import Lateral2 from "../../images/modelos/nuevoaccent2024/disenio/Lateral/lateral2.webp";
import Lateral3 from "../../images/modelos/nuevoaccent2024/disenio/Lateral/lateral3.webp";
import LateralBanner from "../../images/modelos/nuevoaccent2024/disenio/Lateral/banner-lateral.webp";
import Posterior1 from "../../images/modelos/nuevoaccent2024/disenio/Posterior/posterior1.webp";
import Posterior2 from "../../images/modelos/nuevoaccent2024/disenio/Posterior/posterior2.webp";
import Posterior3 from "../../images/modelos/nuevoaccent2024/disenio/Posterior/posterior3.webp";
import PosteriorBanner from "../../images/modelos/nuevoaccent2024/disenio/Posterior/banner-posterior.webp";
import Interior1 from "../../images/modelos/nuevoaccent2024/disenio/Interior/interior1.webp";
import Interior2 from "../../images/modelos/nuevoaccent2024/disenio/Interior/interior2.webp";
import Interior3 from "../../images/modelos/nuevoaccent2024/disenio/Interior/interior3.webp";
import Interior4 from "../../images/modelos/nuevoaccent2024/disenio/Interior/interior4.webp";
import Interior5 from "../../images/modelos/nuevoaccent2024/disenio/Interior/interior5.webp";
/****Fotos rendimiento ****/
import Rendimiento1 from "../../images/modelos/nuevoaccent2024/rendimiento/rendimiento1.webp";
import Rendimiento2 from "../../images/modelos/nuevoaccent2024/rendimiento/rendimiento2.webp";
import Rendimiento3 from "../../images/modelos/nuevoaccent2024/rendimiento/rendimiento3.webp";
/****Fotos seguridad ****/
import Seguridad1 from "../../images/modelos/nuevoaccent2024/seguridad/seguridad1.webp";
import Seguridad2 from "../../images/modelos/nuevoaccent2024/seguridad/seguridad2.webp";
import Seguridad3 from "../../images/modelos/nuevoaccent2024/seguridad/seguridad3.webp";
import Seguridad4 from "../../images/modelos/nuevoaccent2024/seguridad/seguridad4.webp";
import Seguridad5 from "../../images/modelos/nuevoaccent2024/seguridad/seguridad5.webp";
import Seguridad6 from "../../images/modelos/nuevoaccent2024/seguridad/seguridad6.webp";
import Seguridad7 from "../../images/modelos/nuevoaccent2024/seguridad/seguridad7.webp";
import Seguridad8 from "../../images/modelos/nuevoaccent2024/seguridad/seguridad8.webp";
/****Fotos conveniencia ****/
import Conveniencia1 from "../../images/modelos/nuevoaccent2024/conveniencia/conveniencia1.webp";
import Conveniencia2 from "../../images/modelos/nuevoaccent2024/conveniencia/conveniencia2.webp";
import Conveniencia3 from "../../images/modelos/nuevoaccent2024/conveniencia/conveniencia3.webp";
import Conveniencia4 from "../../images/modelos/nuevoaccent2024/conveniencia/conveniencia4.webp";
import Conveniencia5 from "../../images/modelos/nuevoaccent2024/conveniencia/conveniencia5.webp";
/***showroom virtual */
import ShowRoom from "../../images/showroom/accent.png";
/****Ficha técnica ****/
import AccentCatalogo from "../../fichas/accent-brochure.pdf";
import { Accordion, Button, Card } from "react-bootstrap";
import VideoAccent from "../../images/modelos/nuevoaccent2024/nuevo-accent.mp4";

function InfoNuevoAccent() {
    const [gallerySwiper, getGallerySwiper] = useState(null);
    const [thumbnailSwiper, getThumbnailSwiper] = useState(null);
    const gallerySwiperParams = {
        getSwiper: getGallerySwiper,
        loop: true,
        loopedSlides: 5, //looped slides should be the same
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    };

    const thumbnailSwiperParams = {
        getSwiper: getThumbnailSwiper,
        slidesPerView: 5,
        loop: true,
        freeMode: true,
        loopedSlides: 5, //looped slides should be the same
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        centeredSlides: true,
    };

    useEffect(() => {
        if (
            gallerySwiper !== null &&
            gallerySwiper.controller &&
            thumbnailSwiper !== null &&
            thumbnailSwiper.controller
        ) {
            gallerySwiper.controller.control = thumbnailSwiper;
            thumbnailSwiper.controller.control = gallerySwiper;
        }
    }, [gallerySwiper, thumbnailSwiper]);

    const onChangeMenu = (menu) => {
        switch (menu) {
            case "calidad":
                document.getElementById("tab-calidad").className = "color-hover";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-block";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider1;
                break;
            case "disenio":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-hover";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-block";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider2;
                break;
            case "rendimiento":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-hover";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-block";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider3;
                break;
            case "seguridad":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-hover";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-block";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider4;
                break;
            case "conveniencia":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-hover";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-block";
                document.getElementById("img-carrusel").src = Slider5;
                break;
            default:
                break;
        }
    };

    return (
        <Fragment>
            <link rel="preload" as="image" href={Slider1} />
            <link rel="preload" as="image" href={CalidadTiempo1} />
            <link rel="preload" as="image" href={CalidadTiempo2} />
            <link rel="preload" as="image" href={Galeria1} />
            <link rel="preload" as="image" href={Galeria2} />
            <link rel="preload" as="image" href={Galeria3} />
            <link rel="preload" as="image" href={Galeria4} />
            <Container fluid={true}>
                <Row>
                    <Col md={12} className="px-0">
                        <div>
                            <Image
                                src={Slider1}
                                alt="Accent Banner"
                                className="banner"
                                id="img-carrusel"
                                fluid
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
            <div className="menu-vehiculo sticky-top">
                <Container>
                    <Row className="py-2 py-md-4">
                        <Col xs={2} md={2} className="my-auto d-none d-sm-block">
                            <h1 className="menu-modelo">ACCENT</h1>
                        </Col>
                        <Col
                            xs={12}
                            md={6}
                            className="my-auto vehiculo-item text-md-center px-0"
                        >
                            <ul className="my-auto p-0 m-0">
                                <li
                                    id="tab-calidad"
                                    onClick={() => onChangeMenu("calidad")}
                                    className="color-hover"
                                >
                                    Calidad de tiempo
                                </li>
                                <li
                                    id="tab-disenio"
                                    onClick={() => onChangeMenu("disenio")}
                                    className="color-normal"
                                >
                                    Diseño
                                </li>
                                <li
                                    id="tab-rendimiento"
                                    onClick={() => onChangeMenu("rendimiento")}
                                    className="color-normal"
                                >
                                    Rendimiento
                                </li>
                                <li
                                    id="tab-seguridad"
                                    onClick={() => onChangeMenu("seguridad")}
                                    className="color-normal"
                                >
                                    Seguridad
                                </li>
                                <li
                                    id="tab-conveniencia"
                                    onClick={() => onChangeMenu("conveniencia")}
                                    className="color-normal"
                                >
                                    Conveniencia
                                </li>
                            </ul>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra">
                            <a
                                href="static/media/nuevo-accent-ficha-tecnica.6d2c9c9b.pdf"
                                className="text-reset text-decoration-none"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faDownload} />
                                <span className="menu-extra"> Ficha</span>
                            </a>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra px-1">
                            <a
                                href={AccentCatalogo}
                                className="text-reset text-decoration-none"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faDownload} />
                                <span className="menu-extra"> Catálogo</span>
                            </a>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra px-1">
                            <Link
                                to="/cotizador/nuevo-accent"
                                className="text-reset text-decoration-none"
                            >
                                <FontAwesomeIcon icon={faCar} />
                                <span className="menu-extra"> Cotizar</span>
                            </Link>
                        </Col>
                        <Col
                            xs={3}
                            md={1}
                            className="text-center my-auto cont-extra pr-md-0"
                        >
                            <Link
                                to="/test-drive/nuevo-accent"
                                className="text-reset text-decoration-none"
                            >
                                <FontAwesomeIcon icon={faCar} />
                                <span className="menu-extra"> Test Drive</span>
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </div>
            {/***************************************** calidad ***************************************/}
            <section id="calidad">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title">ACCENT</h2>
                            <h2 className="model-title">Audacia en movimiento</h2>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                Uno de los modelos más icónicos y exitosos de Hyundai ha sido completamente rediseñado, 
                                adaptándose a la era digital con innovaciones fascinantes.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        {/*
                        <Col md={12}>
                            <video loop controls
                                style={
                                    {
                                        position: "relative",
                                        width: "100%",
                                        objectFit: "cover",
                                    }
                                }
                            >
                                <source src={VideoAccent} type="video/mp4" />

                            </video>
                        </Col>
                        */}
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col md={6} className="my-auto order-2 order-md-1">
                                <h3 className="specs-subtitle mt-3 px-3 px-md-0">
                                    Audazmente diferente
                                </h3>
                                <p className="specs-text px-3 px-md-0">
                                    En un mundo de modelos parecidos, el Accent destaca por su distintivo diseño:
                                    una exclusiva insignia luminosa que lo distingue en la carretera. La parrilla paramétrica
                                    cromada en negro y las llamativas llantas de aleación añaden los perfectos toques finales.
                                </p>
                            </Col>
                            <Col md={6} className="my-auto order-1 order-md-2">
                                <Image src={CalidadTiempo1} alt="Kona Emocionante" className="img-fluid2" fluid />
                            </Col>
                        </Row>
                        <Row className="py-3 py-md-5">
                            <Col md={6} className="my-auto">
                                <Image src={CalidadTiempo2} alt="Kona Innovacion" className="img-fluid2" fluid />
                            </Col>
                            <Col md={6} className="my-auto">
                                <h3 className="specs-subtitle mt-3 px-3 px-md-0">
                                    Un paso al futuro
                                </h3>
                                <p className="specs-text px-3 px-md-0">
                                    Supera todas las expectativas al ofrecer un rendimiento sólido y un manejo ágil.
                                    Ya sea que manejes por carreteras abiertas o avances lentamente en el tráfico obstruido
                                    de la ciudad, te brindará todas las comodidades que necesites para relajarte y disfrutar
                                    del viaje. Los autos familiares nunca fueron tan divertidos.
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Container>
                    <Row className="py-3 py-md-5">
                        <Col md={12} className="text-center">
                            <h2 className="galeria-titulo my-3 pb-2 pb-md-4">Galería</h2>
                            <div>
                                <Swiper {...gallerySwiperParams}>
                                    <div>
                                        <Image
                                            src={Galeria1}
                                            alt="Accent Slider 1"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria2}
                                            alt="Accent Slider 2"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria3}
                                            alt="Accent Slider 3"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria4}
                                            alt="Accent Slider 4"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria5}
                                            alt="Accent Slider 5"
                                            className="galeria1"
                                        />
                                    </div>
                                </Swiper>
                                <Swiper {...thumbnailSwiperParams}>
                                    <div>
                                        <Image
                                            src={Galeria1}
                                            alt="Accent Slider 1"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria2}
                                            alt="Accent Slider 2"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria3}
                                            alt="Accent Slider 3"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria4}
                                            alt="Accent Slider 4"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria5}
                                            alt="Accent Slider 5"
                                            className="galeria2"
                                        />
                                    </div>
                                </Swiper>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6}></Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("disenio")}
                                    className="titulo-navegacion"
                                >
                                    Diseño
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** disenio ***************************************/}
            <section id="disenio" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title mb-0">Diseño Exterior</h2>
                            <h2 className="model-title-sub">Diseño deportivo.</h2>
                            <p className="model-text mt-3 px-3 px-md-0">
                                El diseño futurista del Accent eleva el coeficiente de alta tecnología y eso ciertamente
                                llamará la atención. La llamativa parilla presenta un diseño paramétrico nuevo y audaz, un acabado
                                cromado para una presentación de primera calidad.
                            </p>
                        </Col>
                    </Row>
                </Container>
                <Container style={{ minHeight: '300px' }} className="cotizador pb-5">
                    <a href="https://my.matterport.com/show/?m=FnVKCkpreEx" target="_blank" rel="noopener noreferrer">
                        <center>
                            <Image src={ShowRoom} alt="Showroom Virtual Grand i10" fluid width={700} height={350} />
                        </center>
                    </a>
                </Container>
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="px-0">
                            <Accordion defaultActiveKey="1" className="acordeon-disenio">
                                <Card>
                                    <Card.Header>
                                        <Accordion.Toggle as={Button} variant="link" eventKey="0">
                                            <Image src={Frontal} alt="Kona Frontal" fluid />
                                        </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="0">
                                        <Container className="my-4 my-md-5">
                                            <Row>
                                                <Col md={6} className="mt-3 mt-md-4">
                                                    <Image src={Frontal2} alt="Kona Luces DRL" fluid />
                                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                                        Rejilla frontal paramétrica cromado negro
                                                    </h3>
                                                </Col>
                                                <Col md={6} className="mt-3 mt-md-4">
                                                    <Image src={Frontal3} alt="Kona Luces MFR" fluid />
                                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                                        Faros halógenos de proyección
                                                    </h3>
                                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                                        Luces diurnas
                                                    </h3>
                                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                                        Neblineros delanteros
                                                    </h3>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="px-0">
                            <Accordion defaultActiveKey="1" className="acordeon-disenio">
                                <Card>
                                    <Card.Header>
                                        <Accordion.Toggle as={Button} variant="link" eventKey="0">
                                            <Image src={LateralBanner} alt="Kona Lateral" fluid />
                                        </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="0">
                                        <Container className="my-4 my-md-5">
                                            <Row>
                                                <Col md={4} className="mt-3 mt-md-4">
                                                    <Image
                                                        src={Lateral1}
                                                        alt="Kona Retrovisores"
                                                        fluid
                                                    />
                                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                                        Espejos eléctricos (conductor + pasajero)

                                                    </h3>
                                                </Col>
                                                <Col md={4} className="mt-3 mt-md-4">
                                                    <Image src={Lateral2} alt="Kona Manijas" fluid />
                                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                                        Manijas color carrocería
                                                    </h3>
                                                </Col>
                                                <Col md={4} className="mt-3 mt-md-4">
                                                    <Image src={Lateral3} alt="Kona Manijas" fluid />
                                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                                        Aros de aleación 15”
                                                    </h3>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="px-0">
                            <Accordion defaultActiveKey="1" className="acordeon-disenio">
                                <Card>
                                    <Card.Header>
                                        <Accordion.Toggle as={Button} variant="link" eventKey="0">
                                            <Image src={PosteriorBanner} alt="Kona Posterior" fluid />
                                        </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="0">
                                        <Container className="my-4 my-md-5">
                                            <Row>
                                                <Col md={4} className="mt-3 mt-md-4">
                                                    <Image
                                                        src={Posterior1}
                                                        alt="Kona Desempaniador"
                                                        fluid
                                                    />
                                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                                        Spoiler deportivo con tercera luz stop
                                                    </h3>
                                                </Col>
                                                <Col md={4} className="mt-3 mt-md-4">
                                                    <Image src={Posterior2} alt="Kona Luces" fluid />
                                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                                        Luces posteriores
                                                    </h3>
                                                </Col>
                                                <Col md={4} className="mt-3 mt-md-4">
                                                    <Image
                                                        src={Posterior3}
                                                        alt="Kona posterior"
                                                        fluid
                                                    />
                                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                                        Cámara posterior
                                                    </h3>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="pt-3 pt-md-5">
                            <Col md={12} className="text-center">
                                <h2 className="model-title mb-0">Diseño Interior</h2>
                                <h2 className="model-title-sub">Espacio, un paso al futuro .</h2>
                                <p className="specs-text mt-3 px-3 px-md-0">Descubre su aspecto y tacto vanguardista.
                                    Las líneas elegantes, las texturas y las combinaciones de colores ofrecen un puro deleite
                                    sensorial.
                                </p>
                                <Image src={Interior1} alt="Kona Interior" fluid />
                            </Col>
                        </Row>
                        <Row className="pb-3 pb-md-2 mt-4">
                            <Col md={4} className="mt-3 mt-md-4">
                                <Image src={Interior2} alt="Kona tablero" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Pantalla táctil de 9" Apple Car Play
                                    / Android Auto
                                </h3>
                            </Col>
                            <Col md={4} className="mt-3 mt-md-4">
                                <Image src={Interior3} alt="Kona Pantalla" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Aire acondicionado manual
                                </h3>
                            </Col>
                            <Col md={4} className="mt-3 mt-md-4">
                                <Image src={Interior4} alt="Kona Luces" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Vidrios eléctricos delanteros y posteriores
                                </h3>
                            </Col>
                        </Row>
                        <Row className="pb-3 pb-md-4">
                            <Col md={12} className="mt-3 mt-md-4">
                                <Image src={Interior5} alt="Kona Interior" fluid />
                            </Col>

                        </Row>
                    </Container>
                </div>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("calidad")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Calidad de tiempo
                                </span>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("rendimiento")}
                                    className="titulo-navegacion"
                                >
                                    Rendimiento
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** rendimiento ***************************************/}
            <section id="rendimiento" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">

                            <h2 className="model-title-sub">Potencia y Desempeño</h2>
                            <h2 className="model-title mb-0">Rendimiento confiable</h2>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                Los motores del Accent ofrecen un rendimiento potente.
                                El motor de gasolina de 1.5 litros de 115 HP y que entrega 147 Nm de torque que
                                presume una relación potencia-peso superior gracias a su construcción totalmente de aluminio.
                            </p>
                        </Col>
                    </Row>
                    <Row className="pb-3 pb-md-4">
                        <Col md={6} className="mt-4 mt-md-4">
                            <Image src={Rendimiento1} alt="Kona tablero" fluid />
                            <h3 className="specs-text mt-3 px-3 px-md-0">
                                Motor Tipo G4FIII 1.5 MPI (Gamma2 1.5 MPI)
                            </h3>
                            <h3 className="specs-text">
                                Potencia máxima (hp@rpm) 115 @ 6.300
                            </h3>
                            <h3 className="specs-text">
                                Torque máximo (Nm@rpm) 147 @ 4.500
                            </h3>
                        </Col>
                        <Col md={6} className="mt-4 mt-md-4">
                            <Image src={Rendimiento2} alt="Kona Pantalla" fluid />
                            <h3 className="specs-text mt-3 px-3 px-md-0">
                                Transmisión Manual 6 velocidades más reversa
                            </h3>
                        </Col>
                    </Row>
                    <Row className="pb-3 pb-md-4 d-flex mt-md-4 justify-content-center">
                        <Col md={12} className="mt-4 mt-md-4">
                            <Image
                                src={Rendimiento3}
                                alt="Kona Banner"
                                className="w-100"
                                fluid
                            />
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("disenio")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Diseño
                                </span>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("seguridad")}
                                    className="titulo-navegacion"
                                >
                                    Seguridad
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** seguridad ***************************************/}
            <section id="seguridad" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title mb-0">Seguridad</h2>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                El Accent viene preparado con un chasis monocasco reforzado, barras de protección
                                lateral contra impactos, marcos de seguridad en las puertas, 6 airbags y demás sistemas
                                que te ayudan a mantenerte seguro a ti y a tu familia en caso de una colisión.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="py-3 px-md-0">
                            <Image src={Seguridad1} alt="Kona Airbag" fluid />
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className='pt-5'>
                            <Col md={4}>
                                <Image src={Seguridad2} alt="Kona Frenos" fluid />
                                <p className="specs-text mt-3 px-3 px-md-0">
                                    6 Airbags (conductor y pasajero + tórax y pelvis + cortina)
                                </p>
                            </Col>
                            <Col md={4}>
                                <Image src={Seguridad3} alt="Kona Cinturones" fluid />
                                <p className="specs-text mt-3 px-3 px-md-0">
                                    Cámara de reversa
                                </p>
                            </Col>
                            <Col md={4}>
                                <Image src={Seguridad4} alt="Kona Cinturones" fluid />
                                <p className="specs-text mt-3 px-3 px-md-0">
                                    Asistente de límite de velocidad manual (MSLA)
                                </p>
                            </Col>
                        </Row>
                        <Row className="py-3 py-md-5">
                            <Col md={4}>
                                <Image src={Seguridad5} alt="Kona Cinturones" fluid />
                                <p className="specs-text px-3 px-md-0">
                                    Asistente de arranque en pendiente (HAC)
                                </p>
                            </Col>
                            <Col md={4}>
                                <Image src={Seguridad6} alt="Kona Carroceria" fluid />
                                <p className="specs-text px-3 px-md-0">
                                    Sistema de anclaje para silla de niños ISOFIX
                                </p>
                            </Col>
                            <Col md={4}>
                                <Image src={Seguridad7} alt="Kona Carroceria" fluid />
                                <p className="specs-text px-3 px-md-0">
                                    Luces Diurnas
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Container>
                    <Row className="justify-content-center pt-5">
                        <Col md={6}>
                            <Image src={Seguridad8} alt="Kona Carroceria" fluid />
                            <h3 className="specs-text mt-3 px-3 px-md-0">
                                Chasis monocasco reforzado
                            </h3>
                            <h3 className="specs-text mt-3 px-3 px-md-0">
                                Barras de protección lateral contra impactos
                            </h3>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("rendimiento")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Rendimiento
                                </span>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("conveniencia")}
                                    className="titulo-navegacion"
                                >
                                    Conveniencia
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** conveniencia ***************************************/}
            <section id="conveniencia" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title">Comodidad absoluta</h2>
                            <p className="model-text mb-md-3 mt-3 px-3 px-md-0">
                                Uno de los modelos más populares y exitosos de Hyundai se ha rediseñado por completo,
                                ahora más audaz y funciones emocionantes. Con su aumento de tamaño brinda mayor comodidad.
                            </p>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col md={4}>
                                <Image
                                    src={Conveniencia1}
                                    alt="Kona mandos integrados volante"
                                    fluid
                                />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Control de audio al volante
                                </h3>
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Bluetooth con reconocimiento de voz
                                </h3>
                            </Col>
                            <Col md={4}>
                                <Image src={Conveniencia2} alt="Kona botón encendido" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Android Auto / Apple Car Play
                                </h3>
                            </Col>
                            <Col md={4}>
                                <Image src={Conveniencia3} alt="Kona ducto ventilación" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Asiento del conductor regulable en altura
                                </h3>
                            </Col>
                        </Row>
                        <Row className="justify-content-center">
                            <Col md={4}>
                                <Image src={Conveniencia4} alt="Kona ducto ventilación" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Asiento posterior plegable 6:4
                                </h3>
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Apoya cabezas en todos los asientos
                                </h3>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Container>
                    <Row className="mt-4 mb-4 mb-md-5">
                        <Col md={12}>
                            <Image src={Conveniencia5} alt="Kona Conveniencia" fluid />
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("seguridad")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Seguridad
                                </span>
                            </Col>
                            <Col xs={6} md={6}></Col>
                        </Row>
                    </Container>
                </div>
            </section>
        </Fragment>
    );
}
export default InfoNuevoAccent;